module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sticky-bora",
    staticStyle: {
      "background-image": "url('images/header.jpg')"
    }
  }, [_c('section', {
    staticClass: "new_bora_logo_area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "main_big_logo_cont"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main_big_logo_cont_bt"
  }, [(!_vm.boraPanorama) ? _c('a', {
    attrs: {
      "href": _vm.webstoreLink
    }
  }, [_vm._v("WEBSHOP")]) : _vm._e()])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "new_header_first_area pano-header",
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    staticClass: "menu_area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "newmainmenu"
  }, [_c('nav', {
    staticClass: "navbar"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "for_mobile"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, _vm._l((_vm.menus), function(m) {
    return _c('li', {
      staticClass: "dropdown"
    }, [(m.link) ? [(m.link.external) ? _c('a', {
      attrs: {
        "href": m.link.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(m.name))]) : _vm._e(), _vm._v(" "), (!m.link.external) ? _c('router-link', {
      attrs: {
        "to": m.link.url,
        "tag": "a"
      }
    }, [_vm._v(_vm._s(m.name))]) : _vm._e()] : _c('a', [_vm._v(_vm._s(m.name))]), _vm._v(" "), (m.children) ? _c('div', {
      staticClass: "dropdown-content",
      staticStyle: {
        "z-index": "100"
      }
    }, [_c('ul', {
      staticClass: "nav navbar-nav"
    }, _vm._l((m.children), function(mm) {
      return _c('li', [(mm.link) ? [(mm.link.external) ? _c('a', {
        attrs: {
          "href": mm.link.url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(mm.name))]) : _vm._e(), _vm._v(" "), (!mm.link.external) ? _c('router-link', {
        attrs: {
          "to": mm.link.url,
          "tag": "a"
        }
      }, [_vm._v(_vm._s(mm.name))]) : _vm._e()] : _c('a', [_vm._v(_vm._s(mm.name))])], 2)
    }))]) : _vm._e()], 2)
  }))])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_big_logo_box text-center"
  }, [_c('img', {
    attrs: {
      "src": "images/bignewlogo.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#for_mobile",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ac5e67d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/bora/BoraHeader.vue
// module id = 276
// module chunks = 2